import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';

import projectService from '../../../../services/project/ProjectService';
import {captureError} from '../../../../utils/log';

function UpgradeProjectButton({projectId, disabled}) {
  const handleUpgradeProject = () => {
    projectService.upgradeProject(projectId)
      .then(() => document.location.reload(true))
      .catch(error => captureError('projectService.upgradeProject', error));
  };

  return (
    <button
      data-id="upgrade-project-button"
      className="large inline-container bo"
      onClick={handleUpgradeProject}
      disabled={disabled}
      tooltip={disabled ? I18n.t('project.upgradeToNominative.tooltip') : undefined}
    >
      <Translate value="project.upgradeToNominative.title"/>
    </button>
  );
}

UpgradeProjectButton.propTypes = {
  projectId: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default UpgradeProjectButton;
